import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { EventCard } from '../../../components/cards';
import SportEventCard from '../../../components/cards/SportEventCard';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { showCompleteRegistration } from '../../../utils/events';

const EventsRegistered = ({ eventsRegistered, history, auth, title, showTennisContent, showPickleballContent }) => {
    const [showAll, setShowAll] = useState();

    return (
        <>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={title} data-testid="dashboard.events-registered.section-heading" />
                        {eventsRegistered?.length > 3 && (
                            <div className={`link clickable`} onClick={() => setShowAll(!showAll)} data-testid="dashboard.events-registered.view-toggle">
                                {showAll ? 'View Less' : 'View All'}
                            </div>
                        )}
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {eventsRegistered.map((event, i) => {
                    if (i <= 2 || (i > 2 && showAll)) {
                        return (
                            <div
                                className={`col-12 col-md-6 col-xl-4`}
                                key={event.id}
                            >
                                <EventCard
                                    event={event}
                                    auth={auth}
                                    force={{
                                        cardView: true,
                                    }}
                                    isOnDashboard={true}
                                    showCompleteRegistration={showCompleteRegistration(event, auth.user?.claimedPlayer?.playerId)}
                                    data-testid={`dashboard.events-registered.item-${event.id}`}
                                />
                            </div>
                        );
                    }
                    return <div />;
                })}
                {eventsRegistered?.length < 3 && (
                    <>
                        {showTennisContent && (
                            <div className="col-12 col-md-6 col-xl-4">
                                <SportEventCard isTennis history={history} data-testid="dashboard.events-registered.cta-tennis" />
                            </div>
                        )}
                        {showPickleballContent && (
                            <div className="col-12 col-md-6 col-xl-4">
                                <SportEventCard history={history} data-testid="dashboard.events-registered.cta-pickleball" />
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

EventsRegistered.propTypes = {
    eventsRegistered: PropTypes.instanceOf(Array),
    auth: PropTypes.objectOf(any).isRequired,
    history: PropTypes.instanceOf(Object),
    title: PropTypes.string,
    showTennisContent: PropTypes.bool,
    showPickleballContent: PropTypes.bool,
};
EventsRegistered.defaultProps = {
    eventsRegistered: [],
    history: {},
    title: '',
    showTennisContent: true,
    showPickleballContent: true,
};

export default EventsRegistered;
